var $9693bc12d96d5761$exports = {};
$9693bc12d96d5761$exports = {
    "loading": `Cargando\u{2026}`,
    "loadingMore": `Cargando m\xe1s\u{2026}`
};


export {$9693bc12d96d5761$exports as default};
//# sourceMappingURL=es-ES.mjs.map
